class ProductHoverQuickAdd extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeElements();
    this.setupEventListeners();
    this.applyCSSIfNoScrollbar();
    this.setupResizeObserver();
  }

  initializeElements() {
    this.elements = {
      forwardButton: this.querySelector('[data-product-hover-quick-add-el="forward"]'),
      backButton: this.querySelector('[data-product-hover-quick-add-el="back"]'),
      scrollableList: this.querySelector('[data-product-hover-quick-add-el="list"]'),
      submit: this.querySelectorAll('[data-product-hover-quick-add-el="submit"]'),
      variantInput: this.querySelector('[data-product-hover-quick-add-el="selectedVariantInput"]')
    };
  }

  setupEventListeners() {
    const { forwardButton, backButton, scrollableList, submit } = this.elements;

    forwardButton.addEventListener('click', this.scrollForward.bind(this));
    backButton.addEventListener('click', this.scrollBackward.bind(this));

    submit.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();

        const variantId = event.currentTarget.getAttribute('data-value');

        this.elements.variantInput.value = variantId;

        window.Moonbase.ajaxCart.handleAddToCartClick(event);
      });
    });
  }

  setupResizeObserver() {
    this.resizeObserver = new ResizeObserver(() => {
      this.applyCSSIfNoScrollbar();
    });

    this.resizeObserver.observe(this.elements.scrollableList);
  }

  hasScrollbar(element) {
    return {
      horizontal: element.scrollWidth > element.clientWidth,
      vertical: element.scrollHeight > element.clientHeight
    };
  }

  applyCSSIfNoScrollbar() {
    const { scrollableList, backButton, forwardButton } = this.elements;
    const { horizontal } = this.hasScrollbar(scrollableList);

    if (!horizontal) {
      scrollableList.style.justifyContent = "center";
      backButton.style.display = 'none';
      forwardButton.style.display = 'none';
    } else {
      scrollableList.style.justifyContent = "start";
      backButton.style.display = 'flex';
      forwardButton.style.display = 'flex';
    }
  }

  scrollForward() {
    this.scrollListBy(this.elements.scrollableList.offsetWidth / 3);
  }

  scrollBackward() {
    this.scrollListBy(-this.elements.scrollableList.offsetWidth / 3);
  }

  scrollListBy(scrollStep) {
    const list = this.elements.scrollableList;
    list.scrollBy({ left: scrollStep, behavior: 'smooth' });
  }
}

customElements.define('product-hover-quick-add', ProductHoverQuickAdd);
